import React, { useEffect, useState, useRef } from "react";
import Dropdown from "./DropdownMovil";
import { useAuth } from '../context/AuthContext';
import "../style/Navbar.css";
import api from "../utils/apiClient";
import LoadingBar from 'react-top-loading-bar';
import { useLocation, Link } from 'react-router-dom';
import { getBooleanEnv } from "../utils/env";

function Navbar() {
  const navRef = useRef();
  const { authToken } = useAuth();
  const [username, setUsername] = useState("");
  const [Isadmin, SetIsadmin] = useState(false);
  const loadingRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const [tel, settel]= useState("")
  const showSellButton = getBooleanEnv("REACT_APP_SHOW_SELL_BUTTON", true);
  const showAdvertisingButton = getBooleanEnv("REACT_APP_SHOW_ADVERTISING_BUTTON", true);
  const showSubastas = getBooleanEnv("REACT_APP_SHOW_SUBASTAS", true);


  const NavtoInsta = () => {
    window.location.href = "https://www.instagram.com/honduautoscom?igsh=MTh1eHJpOHIydmVzOQ==";
  };
  
  const NavtoFace = () => {
    window.location.href = "https://m.facebook.com/honduautos?mibextid=LQQJ4d";
  };
  
  const NavtoWhat = () => {
    window.location.href = "https://l.facebook.com/l.php?u=https%3A%2F%2Fapi.whatsapp.com%2Fsend%3Fphone%3D%252B50499700699%26context%3DARAbAC7ZPDUcgue8K6fARO2i3gW6YABlKSHKfgGBoXVpiqOXnQYkDAu9g5OkOQaLIdNEWEdM1JHowPgda4qXXkNjW8LhDuEugv2y9uCZ_ohEajSUSeCjDe5TdbEYOywM2bDBpICqk8BSUE-FVdYU1fQYzA%26source%3DFB_Page%26app%3Dfacebook%26entry_point%3Dpage_cta%26fbclid%3DIwZXh0bgNhZW0CMTEAAR2WBn_XF0M0stGHfpLDdAy__P1L8OuNSeUGYRh07HTlDqDkyP8qefFjNAY_aem_WSUL9XfeCs3mx_tXA_EUFw&h=AT0WmXmJ0XYKK40nKwKIrBZDArkrcM2N5YcR6dZtIQbNR6m_L3yhFyD_o_sWGCgJ_SX-6gjV20R-nZYgePD_tqjbSYawLKvcEh4Mo9uNrlMjgvcB5z4R0rPRseBiAzA&s=1";
  };
  
  const NavtoTikTok = () => {
    window.location.href = "https://l.facebook.com/l.php?u=https%3A%2F%2Fapi.whatsapp.com%2Fsend%3Fphone%3D%252B50499700699%26context%3DARAbAC7ZPDUcgue8K6fARO2i3gW6YABlKSHKfgGBoXVpiqOXnQYkDAu9g5OkOQaLIdNEWEdM1JHowPgda4qXXkNjW8LhDuEugv2y9uCZ_ohEajSUSeCjDe5TdbEYOywM2bDBpICqk8BSUE-FVdYU1fQYzA%26source%3DFB_Page%26app%3Dfacebook%26entry_point%3Dpage_cta%26fbclid%3DIwZXh0bgNhZW0CMTEAAR2WBn_XF0M0stGHfpLDdAy__P1L8OuNSeUGYRh07HTlDqDkyP8qefFjNAY_aem_WSUL9XfeCs3mx_tXA_EUFw&h=AT0WmXmJ0XYKK40nKwKIrBZDArkrcM2N5YcR6dZtIQbNR6m_L3yhFyD_o_sWGCgJ_SX-6gjV20R-nZYgePD_tqjbSYawLKvcEh4Mo9uNrlMjgvcB5z4R0rPRseBiAzA&s=1";
  };
  

  useEffect(() => {
    if (authToken !== null) {
      fetchContent()
      loadingRef.current.continuousStart(); // Start loading bar
      api.get('usuario/getbyToken').then((res) => {
        setUsername(res.data.nombre);
        const roles = res.data.role;
        const containsSys = roles.includes("sysadmin");
        SetIsadmin(containsSys);
      }).finally(() => {
        setLoading(false);
        loadingRef.current.complete(); // Complete loading bar
      });
    } else {
      fetchContent()
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [isFetching, setIsFetching] = useState(false);

  const fetchContent = async () => {
    if (isFetching) {
      return;
    }
    setIsFetching(true); // Set the flag to indicate the function is running
    try {
      const res = await api.get("content/content/Otros");
      settel(res.data.body);
    } catch (error) {
      console.error('Error fetching content:', error);
    } finally {
      setIsFetching(false); // Reset the flag when the function completes
    }
  };

  const activeSection = {
    "/": "Inicio",
    "/stock": "Buscar",
    "/credit": "Crédito",
    "/subastas": "Subastas",
  }[location.pathname] || "";

  return (
    <>
      <LoadingBar color="#f11946" ref={loadingRef} />
      <nav ref={navRef} className={`fixed-nav ${loading ? 'loading' : ''}`}>
        {/*Red part*/}
        <div className="red-part">
          {/* Mobile-only red strip: the owner wants Políticas always visible;
              the rest of the red-bar links live in the hamburger menu. */}
          <Link to="/politicas" className="politicas-strip-movil">
            <img src="/icons/politica-icon.png" alt="" />
            Políticas y garantías
          </Link>
          <div className="column-1">
            <div className="row-1"></div>
            <div className="row-2"></div>
          </div>
          <div className="column-2"></div>
          {loading ? null : Isadmin ? (
            <div className="red-part-2-admin">
              <Link to="/mycars" className="admin-ref">
                <img src="/icons/user-icon.png" alt="" className="icon-nav"/>
                {username}
              </Link>
              <Link to="/allcarsa" className="admin-ref">
                <img src="/icons/store.png" alt="" className="icon-nav" />
                Administrar
              </Link>
              <Link to="/notificationsadmin" className="admin-ref">
                <img src="/icons/campana.png" alt="" className="icon-nav" />
              </Link>
              <Link to="/politicas" className="admin-ref">
                <img src="/icons/politica-icon.png" alt="" className="icon-nav" />
                Políticas y garantías
              </Link>
            </div>
          ) : (
            <div className="red-part-2">
              <img style={{cursor : "pointer"}} onClick={NavtoInsta} src="/icons/contact-icon.png" alt="" className="icon-nav" id="insta"/>
              <img style={{cursor : "pointer"}} onClick={NavtoWhat} src="/icons/white-whatsapp.png" alt="" className="icon-nav" id="insta"/>
              <img style={{cursor : "pointer"}} onClick={NavtoFace} src="/icons/white-facebook.png" alt="" className="icon-nav" id="insta"/>
              <img style={{cursor : "pointer"}} onClick={NavtoTikTok} src="/icons/white-tiktok.png" alt="" className="icon-nav" id="insta"/>
              <Link className="white-link" to="/contact">
                <img src="/icons/white-phone.png" alt="" className="icon-nav" id="insta"/>
                Contáctenos
              </Link>
              {authToken ? (
                <Link className="white-link" to="/mycars">
                  <img src="/icons/user-icon.png" alt="" className="icon-nav" />
                  {username}
                </Link>
              ) : (
                <Link className="white-link" to="/login">
                  <img src="/icons/user-icon.png" alt="" className="icon-nav" />
                  Iniciar sesión
                </Link>
              )}
              {authToken && !Isadmin && showSellButton && (
                <Link className="white-link" to="/sell">
                  <img src="/icons/vende-icon.png" alt="" className="icon-nav" />
                  Vende tu auto
                </Link>
              )}
              {showAdvertisingButton && (
                <Link className="white-link" to="/advertising">
                  <img src="/icons/banner-white.png" alt="" className="icon-chiquito" />
                   Publicita tu marca
                </Link>
              )}
              <Link className="white-link" to="/politicas">
                <img src="/icons/politica-icon.png" alt="" className="icon-nav" />
                Políticas y garantías
              </Link>
            </div>
          )}
        </div>
        {/*Grey part */}
        <div className="grey-part">
          {/* Logo image*/}
          <Link to="/" className={`tomain ${loading ? 'loading' : ''}`}>
            <img
              src="/images/honduautos-logo.png"
              alt="Logo de honduautos"
              className="logo-honduautos"
            />
          </Link>
          {/* Navigation links */}
          <div className="menu-grid">
            <Link to="/" className={`nav-link ${activeSection === "Inicio" ? "active" : ""}`}>
              Inicio
            </Link>
            <Link to="/stock" className={`nav-link ${activeSection === "Buscar" ? "active" : ""}`}>
              Buscar
            </Link>
            <Link to="/credit" className={`nav-link ${activeSection === "Crédito" ? "active" : ""}`}>
              Crédito
            </Link>
            {showSubastas && (
              <Link to="/subastas" className={`nav-link ${activeSection === "Subastas" ? "active" : ""}`}>
              Subastas
            </Link>
            )}
            <div className="drop-movil"><Dropdown/></div>
          </div>
          {/* Phone number and social media logos */}
          <div className="phone-logos-container">
            <p id="phone">Llámenos al {tel}</p>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
